// Runtime configuration. Centralized so feature flags and tunables are
// discoverable and easy to flip without scanning the codebase.

import { ALL_ROWS } from "../components/ui/Pagination";

export const API_URL = process.env.REACT_APP_API_URL;
export const REMOTE_FILES_BASE_URL =
    process.env.REACT_APP_REMOTE_FILES_BASE_URL || "https://portal.summitdoors.ca/files";

// Phase 1 server-driven pagination flag. Set to false to fall back to the
// legacy single-load behavior if a regression appears in production.
export const SERVER_PAGINATION_ENABLED = true;

/**
 * Global pagination options shared by every paginated DataTable in the
 * app. Includes an "All" option (sentinel -1) that disables paging on
 * client-side tables, and is translated to a high API limit on
 * server-paginated tables (see API_ALL_LIMIT).
 */
export const PAGE_SIZE_OPTIONS = [
    { value: 25, label: "25" },
    { value: 100, label: "100" },
    { value: 250, label: "250" },
    { value: 500, label: "500" },
    { value: ALL_ROWS, label: "All" },
];

export const DEFAULT_PAGE_SIZE = 25;

/**
 * Resolve a UI-layer rows-per-page value (which may be the ALL_ROWS
 * sentinel) to the limit we send to the API.
 */
export const API_ALL_LIMIT = 100000;
export const resolveApiLimit = (rowsPerPage) =>
    rowsPerPage === ALL_ROWS ? API_ALL_LIMIT : rowsPerPage;

// Backwards-compatible aliases (kept until all consumers migrate).
export const SALES_PAGE_SIZE_OPTIONS = PAGE_SIZE_OPTIONS;
export const DEFAULT_SALES_PAGE_SIZE = DEFAULT_PAGE_SIZE;
export const CUSTOMERS_PAGE_SIZE_OPTIONS = PAGE_SIZE_OPTIONS;
export const DEFAULT_CUSTOMERS_PAGE_SIZE = DEFAULT_PAGE_SIZE;

export const SEARCH_DEBOUNCE_MS = 350;
